const handler = ( $ ) => {
	const initAccordion = () => {
		const $accordions = $( '.accordion-faq' );

		if ( ! $accordions.length ) return;

		// Initialize each accordion separately
		$accordions.each( function () {
			const $accordion = $( this );
			const $items = $accordion.find( '.accordion-faq__item' );
			const $heads = $accordion.find( '.accordion-faq__item-head' );
			const $contents = $accordion.find( '.accordion-faq__content' );

			// Close all items initially
			$contents.slideUp( 0 );

			// Open first item in each accordion on init
			const $firstItem = $items.first();
			const $firstHead = $firstItem.find( '.accordion-faq__item-head' );
			const $firstContent = $firstItem.find( '.accordion-faq__content' );

			$firstItem.addClass( 'is-active' );
			$firstHead.attr( 'aria-expanded', 'true' );
			$firstContent.slideDown( 0 );

			$heads.on( 'click', function ( e ) {
				e.preventDefault();
				const $button = $( this );
				const $item = $button.closest( '.accordion-faq__item' );
				const $content = $item.find( '.accordion-faq__content' );
				const isActive = $item.hasClass( 'is-active' );

				// Close other items in this accordion only
				const $otherItems = $accordion
					.find( '.accordion-faq__item' )
					.not( $item );
				$otherItems.removeClass( 'is-active' );
				$otherItems.find( '.accordion-faq__content' ).slideUp( 300 );
				$otherItems
					.find( '.accordion-faq__item-head' )
					.attr( 'aria-expanded', 'false' );

				// Toggle current item
				if ( isActive ) {
					// Close current item if it's active
					$item.removeClass( 'is-active' );
					$content.slideUp( 300 );
					$button.attr( 'aria-expanded', 'false' );
				} else {
					$item.addClass( 'is-active' );
					$content.slideDown( 300 );
					$button.attr( 'aria-expanded', 'true' );
				}
			} );
		} );
	};

	// Initialize on DOM ready
	initAccordion();
};

export default ( ( $ ) => $( handler ) )( jQuery );
